import Error from "@/assets/images/error.svg";
import { Button, Flex, theme, Typography } from "antd";
import { useTranslation } from "react-i18next";

export const ErrorScreen = () => {
  const { token } = theme.useToken();
  const { t } = useTranslation();
  return (
    <Flex
      justify="center"
      align="center"
      vertical
      gap={token.marginLG}
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <img src={Error} title={t("an_error_occurred")} width={256} />
      <Typography.Text type="secondary">
        {t("an_error_occurred")}
      </Typography.Text>
      <Button
        type="primary"
        onClick={() => {
          window.location.reload();
        }}
      >
        {t("contact_us")}
      </Button>
    </Flex>
  );
};
